
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./call_timeline_extension": () => {
return Promise.all([__webpack_require__.e("567"), __webpack_require__.e("355"), __webpack_require__.e("421"), __webpack_require__.e("587")]).then(() => (() => (__webpack_require__(42073))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };